import { render, staticRenderFns } from "./ExamineeResult.vue?vue&type=template&id=d83924d4&scoped=true&"
import script from "./ExamineeResult.vue?vue&type=script&lang=js&"
export * from "./ExamineeResult.vue?vue&type=script&lang=js&"
import style0 from "./ExamineeResult.vue?vue&type=style&index=0&id=d83924d4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83924d4",
  null
  
)

export default component.exports